import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Typography,
  Avatar,
  Divider,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HttpsIcon from "@mui/icons-material/Https";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { UseComment } from "./UseComment";
import { rsActiveMenu, rsScrollCk, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { Link } from "react-router-dom";

export default function CommentsAcc(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [commentsRes, setCommentsRes] = useState([]);
  const [expanded, setExpanded] = useState("panel1");
  const { GetCommentByID } = UseComment();
  const [detailCom, setDetailCom] = useState();

  const handleChange = (panel) => (event, isExpanded) => {
    setDetailCom();
    setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      setProgress(true);
      GetCommentByID(panel, (callBack) => {
        setDetailCom(callBack);
      });
    }
  };

  useEffect(() => {
    if (props.commentsRes) {
      setCommentsRes(props.commentsRes);
    }
  }, [props.commentsRes]);

  return (
    <Box sx={{ pb: 3 }}>
      {commentsRes &&
        commentsRes.map((model, i) => {
          return (
            <Accordion
              expanded={expanded === model.id}
              onChange={handleChange(model.id)}
              style={{}}
            >
              <AccordionSummary
                sx={{ mb: 0, bgcolor: "#b5ed9a" }}
                // onChange={() => handleChange(model.commentID)}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ direction: "rtl" }}
                  variant="subtitle2"
                  color="seconddary"
                >
                  {model.shamsiDate}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "#F5F5F5",
                    boxShadow: "-2px 8px 8px 0px #14141433",
                    p: 2,
                  }}
                >
                  {detailCom &&
                    detailCom.conversation &&
                    detailCom.conversation.map((model, i) => {
                      return (
                        <Box
                          key={i}
                          sx={{
                            ml: i !== 0 ? 4 : 0,
                            mb: 2,
                            borderLeft: i !== 0 && "3px solid",
                            borderColor: window.ENV.primary,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              ml: i !== 0 && 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Avatar
                                sx={{ mr: 1 }}
                                src={model.avatar}
                              ></Avatar>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color:
                                      model.userName == "داروکده" &&
                                      "primary.main",
                                  }}
                                  variant="subtitle1"
                                >
                                  {model.userName}
                                </Typography>
                                <Typography variant="caption">
                                  {model.id}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {model.isPrivate == false ? (
                                <Tooltip title="خصوصی">
                                  <IconButton sx={{ p: 0, mr: 2 }}>
                                    <HttpsIcon
                                      sx={{
                                        color: "secondary.main",
                                      }}
                                      // fontSize="small"
                                    />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <Tooltip title="غیرخصوصی">
                                  <IconButton sx={{ p: 0, mr: 2 }}>
                                    <LockOpenIcon
                                      sx={{
                                        color: "primary.main",
                                      }}
                                      // fontSize="small"
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              mt: 2,
                              ml: i !== 0 && 2,
                            }}
                          >
                            <Avatar sx={{ mr: 1, visibility: "hidden" }}>
                              {model.avatar}
                            </Avatar>
                            <Typography
                              sx={{ whiteSpace: "pre-wrap" }}
                              variant="subtitle2"
                              dangerouslySetInnerHTML={{
                                __html: model.message,
                              }}
                            ></Typography>
                          </Box>
                          <Divider sx={{ m: 2, mb: 0 }} />
                        </Box>
                      );
                    })}
                </Box>
              </AccordionDetails>
            </Accordion>
          );
        })}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Link
          target="_blank"
          to={{
            pathname: "/comments",
            hash: props.mobile,
          }}
        >
          <Button variant="contained" color="secondary">
            نمایش کامل
          </Button>
        </Link>
      </Box>
    </Box>
  );
}
